function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4ecca3;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1.32,0,735.49,139.77,789.82,265,303.47,151.64Q535.39,261.1,656,369.21t120.6,207q0,48.78-33.13,79.11-31.82,30.33-86.14,30.33-30.48,0-86.14-14.5L515.51,658,353.83,618.42l-51.68-13.18q-79.51-19.79-121.92-19.78T111.32,600q-25.18,14.5-25.18,38.24,0,40.88,98.07,130.54l-18.56,21.1-14.57-13.18q-88.8-75.17-120.6-110.77Q0,630.29,0,600q0-40.87,41.08-69.88,42.4-27.69,104.69-27.69,42.4,0,125.9,15.82l280.94,51.43q66.26,10.54,92.76,10.55,27.84,0,42.41-14.51t14.58-39.56q0-91-196.14-224.16-94.08-64.62-186.85-106.81Q227.93,153,64.93,100.21L29.15,88.35,1.32,0Z"
})));

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "150px",
    viewBox: "0 0 789.82 789.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8f0657e4.svg";
export { ForwardRef as ReactComponent };